export const ZolaTermsLink = (): JSX.Element => (
  <a href="/terms" target="_blank" rel="noopener noreferrer">
    Terms of Use
  </a>
);

export const ZolaPrivacyLink = (): JSX.Element => (
  <a href="/privacy" target="_blank" rel="noopener noreferrer">
    Privacy Policy
  </a>
);

export const ZolaVendorCreditsTermsLink = (): JSX.Element => {
  return (
    <a href="/vendor-plans-terms" target="_blank" rel="noopener noreferrer">
      Vendor Plans Terms and Conditions
    </a>
  );
};
